import {Component, OnInit} from '@angular/core';
import {PrintingDataAnimal, PrintingTemplate} from '../../TemplateTypes';
import {ActionSpecificPrintingComponent} from '../action-specific-printing-component';
import {AnimalEntryModel} from '../../../../shared/models/animal/animal-entry.model';
import {PersonEntryModel} from '../../../../shared/models/person-entry.model';
import {Age, CastrationStatus, Constants, Gender, Shelter} from '../../../../shared/constants';
import {CharacteristicService} from '../../../../animals/store/characteristics/characteristic.service';

@Component({
    selector: 'app-annahme-pensionstier-printing',
    templateUrl: './annahme-pensionstier-printing.component.html',
    styleUrls: ['./annahme-pensionstier-printing.component.scss']
})
export class AnnahmePensionstierPrintingComponent implements ActionSpecificPrintingComponent, OnInit {
    public hideHeader = false;
    public printingTemplate = PrintingTemplate.ActionSpecific;
    public visible = false;
    public data: PrintingDataAnimal;
    public animals: AnimalEntryModel[];
    public person: PersonEntryModel;
    public shelter: Shelter;
    public Shelter = Shelter;
    public Constants = Constants;
    public Gender = Gender;
    public CastrationStatus = CastrationStatus;
    public Age = Age;

    public owner: PersonEntryModel;
    public cityName = '';
    public shelterName = '';

    constructor(private characteristicsService: CharacteristicService) {
    }

    ngOnInit(): void {
        if (this.shelter === Shelter.LINZ) {
            this.cityName = Constants.LinzCityName;
            this.shelterName = Constants.LinzShelterName;
        } else {
            this.cityName = Constants.SteyrCityName;
            this.shelterName = Constants.SteyrShelterName;
        }

        if (this.data.owner && typeof this.data.owner !== 'undefined') {
            this.owner = this.data.owner;
        } else {
            this.owner = this.person;
        }
    }
}
